// removed by extract-text-webpack-plugin
module.exports = {"container":"_21oE5Bb9go6U4E7mN6XWe","img":"_-S5_LzQQU_FwH64TF-xp"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Banner/Logo/styles.scss
 ** module id = 467
 ** module chunks = 0
 **/